import { UserB } from "app/pages/ok-admin/user-b/user-b"
import { Comment } from "./comment"

export class Request {
    id: string

    title: string

    typeService: string

    typeServiceString: string

    creationDate: Date

    endDate: string

    description: string

    userRequested: UserB

    usersBReceived: UserB

    usersClientReceived: UserB

    fileUrl: string

    comments: Comment[]

    viewed: Boolean

    status: string

    type: string

    canceledReason: string

    code: number

    idDocumentFile: string

    responsible: UserB

    cnpj: string
}